(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-inspiration-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const cards = [...gallery.querySelectorAll('[data-project-card]')];
      const count = gallery.querySelector('[data-gallery-count]');
      count.textContent = count.dataset.countTemplate.replace('__COUNT__', cards.length);
      gallery.querySelectorAll('[data-gallery-filter]').forEach(button => {
        button.addEventListener('click', () => {
          gallery.querySelectorAll('[data-gallery-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          cards.forEach(card => { card.hidden = button.dataset.galleryFilter !== 'all' && card.dataset.model !== button.dataset.galleryFilter; });
          count.textContent = count.dataset.countTemplate.replace('__COUNT__', cards.filter(card => !card.hidden).length);
        });
      });
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
